import { render, staticRenderFns } from "./viewMenuUserList.vue?vue&type=template&id=37fad9d4&scoped=true"
import script from "./viewMenuUserList.vue?vue&type=script&lang=js"
export * from "./viewMenuUserList.vue?vue&type=script&lang=js"
import style0 from "./viewMenuUserList.vue?vue&type=style&index=0&id=37fad9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fad9d4",
  null
  
)

export default component.exports